import React, { useState } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import { BooleanInput } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {
  Active: true
};
function VendorFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...inputs };
    if (e.target.name.includes("RecIdRef")) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <Label>Vendor #</Label>
          <Input
            autocomplete="new"
            name="VendorNo_contains"
            type="text"
            value={inputs.VendorNo_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Vendor Name</Label>
          <Input
            autocomplete="new"
            name="Name_contains"
            type="text"
            value={inputs.Name_contains}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <Field kind="group">
        <Control expanded>
          <Label>City</Label>
          <Input
            autocomplete="new"
            name="City_contains"
            type="text"
            value={inputs.City_contains}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>

      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
VendorFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
VendorFilters.defaultProps = {
  filters: {}
};
export default VendorFilters;
